import React from "react";
import { FormattedMessage } from "react-intl";

const Label = ({className, text}) => <p className={className}><FormattedMessage id={text} /></p>

export default Label;
